import { render, staticRenderFns } from "./CopyReport.vue?vue&type=template&id=61a4b703&scoped=true&"
import script from "./CopyReport.vue?vue&type=script&lang=js&"
export * from "./CopyReport.vue?vue&type=script&lang=js&"
import style0 from "@/css/styleModules.css?vue&type=style&index=0&id=61a4b703&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a4b703",
  null
  
)

export default component.exports